import axios from 'axios';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react'
import { Modal, Button, Form, InputGroup } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import useHandleErrors from '../../utils/user.utils';
import { utils, write } from 'xlsx';
import { saveAs } from 'file-saver';
import { useUser } from '../../utils/userContext';
import Select from 'react-select';


export default function AssignProject() {
    const [assignProjects, setAssignProjects] = useState([]);
    const [projects, setProjects] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [updateShowModal, setUpdateShowModal] = useState(false);
    const [selectedProject, setSelectedProject] = useState(null);
    const [selectedProjectCode, setSelectedProjectCode] = useState('');
    const [loading, setLoading] = useState(false);
    const [resources, setResources] = useState([]);
    const token = localStorage.getItem("token");
    const { user } = useUser();
    const hasFetchedRef = useRef(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredProjects, setFilteredProjects] = useState([]);
    const [formData, setFormData] = useState({
        ProjectName: '',
        StartDate: '',
        EndDate: '',
        Description: '',
        Resource: '',
        ProjectStatus: 'Assigned',
        UpdatedBy: user?.EmployeeId

    });
    const handleErrors = useHandleErrors();


    const fetchProjects = async () => {
        const path = "/getProjectDetails";
        const URL = process.env.REACT_APP_BE_URL + path;
        try {
            const response = await axios.get(URL, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.status === 200) {
                const activeProjects = response.data.GetOnboardedProjects.filter(
                    (project) => {
                        const status = project.ProjectStatus.toLowerCase();
                        return status === "active" || status === "assigned";
                    }
                );
                setProjects(activeProjects);
            } else {
                handleErrors(response);
            }
        } catch (error) {
            console.error('Error fetching assignProjects:', error);
            if (error.response) {
                if (error.response.status === 404) {
                    setProjects([]);
                } else {
                    handleErrors(error.response);
                }
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        }
    };

    const fetchResources = async () => {
        const path = "/getEmployeeMasterReport";
        const URL = process.env.REACT_APP_BE_URL + path;
        try {
            const response = await axios.get(URL, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.status === 200) {
                setResources(response.data.onboardEmployeeDetails);
            } else {
                handleErrors(response);
            }
        } catch (error) {
            console.error('Error fetching assignProjects:', error);
            if (error.response) {
                handleErrors(error.response);
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        }
    };

    const fetchAssignProjectDetails = async () => {
        setLoading(true)
        try {
            const path = "/getAssignProjectDetails";
            const URL = process.env.REACT_APP_BE_URL + path;
            const response = await axios.get(URL, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            if (response.status === 200) {
                const formattedProjects = response.data.listProjects.map(project => ({
                    ...project,
                }));
                setAssignProjects(formattedProjects);
            } else {
                handleErrors(response);
            }
        } catch (error) {
            if (error.response) {
                handleErrors(error.response);
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (!hasFetchedRef.current) {
            fetchAssignProjectDetails()
            fetchProjects();
            fetchResources();
            hasFetchedRef.current = true;
        }
    }, []);


    const handleShow = () => setShowModal(true);
    const handleClose = () => {
        setShowModal(false);
        setFormData({
            ProjectName: '',
            StartDate: '',
            EndDate: '',
            Description: '',
            Resource: '',
            ProjectStatus: '',
            UpdatedBy: ""
        })
    }
    const handleUpdateClose = () => setUpdateShowModal(false);


    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === 'ProjectName') {
            setFormData(prevState => ({
                ...prevState,
                [name]: value
            }));
            const selectedProject = projects.find(project => project.ProjectName === value);
            if (selectedProject) {
                setSelectedProjectCode(selectedProject.ProjectCode);
            } else {
                setSelectedProjectCode('');
            }
        } else if (name === 'Resource') {
            if (value !== "Select Resource" && !formData.Resource.includes(value)) {
                setFormData(prevState => ({
                    ...prevState,
                    Resource: value
                }));
            }
        } else {
            setFormData(prevState => ({
                ...prevState,
                [name]: value
            }));
        }
    };

    const handleUpdateChange = (e) => {
        const { name, value } = e.target;

        if (name === 'Resource') {
            if (value !== "Select Resource" && !selectedProject.resource.includes(value)) {
                setSelectedProject((prevProject) => ({
                    ...prevProject,
                    resource: value
                }));
            }
        } else if (name === 'StartDate') {
            setSelectedProject((prevProject) => ({
                ...prevProject,
                startDate: value
            }));
        } else if (name === 'EndDate') {
            setSelectedProject((prevProject) => ({
                ...prevProject,
                endDate: value
            }));
        } else {
            const { name, value } = e.target;
            setSelectedProject((prevProject) => ({
                ...prevProject,
                [name]: value,
            }));
        }
    };

    const handleUpdate = async () => {
        setLoading(true);
        try {
            const path = "/assignProject";
            const URL = process.env.REACT_APP_BE_URL + path;
            const updatedProject = {
                ...selectedProject,
                ProjectCode: selectedProject.ProjectCode,
            };
            const response = await axios.post(URL, updatedProject, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            if (response.status === 200) {
                console.log('Project updated successfully:', response);
                setUpdateShowModal(false);
                toast.success("Project onboarded successfully!", {
                    position: toast.POSITION.TOP_CENTER,
                });
                fetchAssignProjectDetails()
            } else {
                handleErrors(response);
            }
        }
        catch (error) {
            console.error('There was an error updating the project!', error);
            if (error.response) {
                handleErrors(error.response);
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        } finally {
            setLoading(false);
        }
    };

    const handleUpdateShow = (project) => {
        setSelectedProject(project);
        setUpdateShowModal(true);
    };

    const handleSubmit = async () => {
        setLoading(true);
        if (!formData.ProjectName) {
            toast.error("ProjectName is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        if (!formData.Resource) {
            toast.error("Resource is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        if (!formData.StartDate) {
            toast.error("StartDate is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        if (!formData.EndDate) {
            toast.error("EndDate is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        try {
            const path = "/assignProject";
            const URL = process.env.REACT_APP_BE_URL + path;
            const Payload = {
                ...formData,
                ProjectCode: selectedProjectCode,
                ProjectStatus: 'Assigned',
                UpdatedBy: user?.EmployeeId
            };

            const response = await axios.post(URL, Payload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            if (response.status === 200) {
                console.log('Project Assigned successfully:', response);
                handleClose();
                toast.success("Project Assigned successfully!", {
                    position: toast.POSITION.TOP_CENTER,
                });
                setFormData({
                    ProjectName: '',
                    StartDate: '',
                    EndDate: '',
                    Description: '',
                    Resource: '',
                    ProjectStatus: '',
                    UpdatedBy: ''
                })
            } else {
                handleErrors(response);
            }
        }
        catch (error) {
            console.error('There was an error onboarding the project!', error);
            if (error.response) {
                handleErrors(error.response);
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        }
        finally {
            setLoading(false);
        }
    };

    const sendEmail = (email) => {
        // Excel generation logic
        const ws = utils.json_to_sheet(projects);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, 'Projects');
        const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' });

        // Convert the Excel file to a Base64 string
        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        const reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onloadend = () => {
            const base64data = reader.result.split(',')[1]; // Get the Base64 string without the prefix

            // Create a downloadable link for the attachment
            const link = document.createElement('a');
            link.href = reader.result;
            const today = new Date();
            const year = today.getFullYear().toString().slice(-2); // Get last two digits of the year
            const month = (today.getMonth() + 1).toString().padStart(2, '0'); // Add leading 0 for month
            const day = today.getDate().toString().padStart(2, '0'); // Add leading 0 for day
            const formattedDate = `${year}${month}${day}`;
            link.download = `WW360-Assign_Projects_Report_${formattedDate}.xlsx`;

            // Simulate a click to download the attachment
            link.click();

            // Prepare the mailto link (without attachment)
            const subject = "Projects List";
            const body = 'Please find the attached file.';
            const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

            toast.info('The Excel file has been generated and downloaded. Please attach the file manually to your email.', {
                position: toast.POSITION.TOP_CENTER,
            });

            setTimeout(() => {
                window.location.href = mailtoLink;
            }, 3000);

        };
    };

    const handleExport = () => {
        const ws = utils.json_to_sheet(projects);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, 'Projects');
        const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        const today = new Date();
        const year = today.getFullYear().toString().slice(-2); // Get last two digits of the year
        const month = (today.getMonth() + 1).toString().padStart(2, '0'); // Add leading 0 for month
        const day = today.getDate().toString().padStart(2, '0'); // Add leading 0 for day
        const formattedDate = `${year}${month}${day}`;
        saveAs(data, `WW360-Assign_Projects_Report_${formattedDate}.xlsx`);
    };

    const shareData = {
        title: 'Projects List',
        text: 'Check out the Projects list',
        url: window.location.href
    };

    useEffect(() => {
        // Filter employees based on the search query
        setFilteredProjects(
            assignProjects.filter(assignProject =>
                assignProject?.resource.toLowerCase().includes(searchQuery.toLowerCase()) ||
                assignProject.employeeName.toLowerCase().includes(searchQuery.toLowerCase()) ||
                assignProject.projectCode.toLowerCase().includes(searchQuery.toLowerCase()) ||
                assignProject.projectName.toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
    }, [searchQuery, assignProjects]);

    const handleShare = async () => {
        try {
            await navigator.share(shareData);
        } catch (err) {
            console.error('Error sharing:', err);
        }
    };

    const handleRecordsPerPageChange = (event) => {
        setRecordsPerPage(Number(event.target.value));
        setCurrentPage(1);
    };

    const Projectoptions = projects.map(project => ({
        value: project.ProjectName,
        label: project.ProjectName
    }));


    const Resourceoptions = resources.map(resource => ({
        value: resource.EmployeeId,
        label: resource.OfficialEmail
    }));

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = filteredProjects.slice(indexOfFirstRecord, indexOfLastRecord);
    const totalPages = Math.ceil(filteredProjects.length / recordsPerPage);

    const paginate = pageNumber => setCurrentPage(pageNumber);

    const ClearIndicator = () => null;
    return (
        <div>
            {loading && (
                <div id="preloading">
                    <span className="loader"></span>
                </div>
            )}
            <ToastContainer />
            <div className="content-page">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col">
                            <h3 className="title mb-2">Assign Project</h3>
                        </div>
                        <div className="col-auto">
                            <Button variant="primary" onClick={handleShow}>
                                <i class="ri-checkbox-circle-line"></i> Assign New
                            </Button>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card mb-4">
                                <div className="card-body">
                                    <div className="row align-items-center justify-content-center">
                                        <div className="col-lg-5 col-md-8 col-sm-10">
                                            <div className="container-fluid row-rounded mb-0">
                                                <div className="row px-2 py-0">
                                                    <div className="input-group mb-0">
                                                        <input
                                                            type="search"
                                                            className="form-control search-input"
                                                            placeholder="Keyword search..."
                                                            value={searchQuery}
                                                            onChange={(e) => setSearchQuery(e.target.value)}
                                                        />
                                                        <div className="input-group-append">
                                                            <button className="btn btn-primary" type="button" title="Search" rel="tooltip">
                                                                <i className="ri-menu-search-line"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <small className="form-text text-muted text-center mt-0">
                                                <i className="ri-information-2-fill text-info"></i> Allows: Employee Id - Employee Name - Project Code - Project Name
                                            </small>
                                        </div>
                                    </div>
                                    {currentRecords?.length === 0 ? (
                                        <div class="container">
                                            <div class="row vh-50 justify-content-center align-items-center">
                                                <div class="col-auto">
                                                    <div class="no-data-wrapper">
                                                        <div class="no-data-found">
                                                            <i class="ri-file-damage-fill"></i>
                                                            <div class="bounce"><i class="ri-search-eye-line"></i></div>
                                                            <p>No Data Found</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div>
                                            <div class="row">
                                                <div class="col">
                                                    <h5 class="title mt-1 mb-0">Project Summary</h5>
                                                </div>
                                                <div className="col-auto">
                                                    <button type="button" title="Email" className="btn btn-light btn-circle ml-2" onClick={() => sendEmail('')}>
                                                        <i className="ri-mail-send-fill"></i>
                                                    </button>
                                                    <button type="button" title="Share" className="btn btn-light btn-circle ml-2" onClick={handleShare}>
                                                        <i className="ri-share-fill"></i>
                                                    </button>
                                                    <button type="button" title="Export" className="btn btn-light btn-circle ml-2" onClick={handleExport}>
                                                        <i className="ri-export-fill"></i>
                                                    </button>
                                                </div>
                                            </div>

                                            <div className="row mt-3">
                                                <div className="col-md-12">
                                                    <div className="table-responsive asset-information">
                                                        <table className="table grid">
                                                            <thead className="bg-light">
                                                                <tr>
                                                                    <th>S.No.</th>
                                                                    <th>Emp Id </th>
                                                                    <th>Emp Name </th>
                                                                    <th>Project Name  </th>
                                                                    <th>Project Code  </th>
                                                                    <th>Start Date  </th>
                                                                    <th>End Date  </th>
                                                                    <th></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {currentRecords.map((project, index) => (
                                                                    <tr key={index}>
                                                                        <td>{index + 1 + indexOfFirstRecord}</td>
                                                                        <td>{project.resource}</td>
                                                                        <td>{project.employeeName}</td>
                                                                        <td>{project.projectName}</td>
                                                                        <td>{project.projectCode}</td>
                                                                        <td>{moment(project.startDate).format("DD-MM-YYYY")}</td>
                                                                        <td>{moment(project.endDate).format("DD-MM-YYYY")}</td>
                                                                        <td className="text-center">
                                                                            <Button variant="link" className="text-info" onClick={() => handleUpdateShow(project)}><i className="ri-list-settings-line"></i></Button>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>

                                                        </table>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="container-fluid">
                                                        <div className="row border-top pt-3">
                                                            <div className="col-auto">
                                                                <p className="mt-1 mb-0">Records</p>
                                                            </div>
                                                            <div className="col-1 record-drop">
                                                                <select className="form-control" value={recordsPerPage} onChange={handleRecordsPerPageChange}>
                                                                    <option value="5">5</option>
                                                                    <option value="10">10</option>
                                                                    <option value="15">15</option>
                                                                    <option value="20">20</option>
                                                                    <option value="25">25</option>
                                                                </select>
                                                            </div>
                                                            <div className="col">
                                                                <nav>
                                                                    <ul className="pagination justify-content-center">
                                                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => paginate(1)} tabIndex="-1">
                                                                                <i className="ri-arrow-left-double-line"></i>
                                                                            </button>
                                                                        </li>
                                                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => paginate(currentPage - 1)} tabIndex="-1">
                                                                                <i className="ri-arrow-left-s-line"></i>
                                                                            </button>
                                                                        </li>
                                                                        {Array.from({ length: totalPages }, (_, index) => (
                                                                            <li key={index + 1} className={`page-item ${index + 1 === currentPage ? 'active' : ''}`}>
                                                                                <button className="page-link" onClick={() => paginate(index + 1)}>
                                                                                    {index + 1}
                                                                                </button>
                                                                            </li>
                                                                        ))}
                                                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => paginate(currentPage + 1)}>
                                                                                <i className="ri-arrow-right-s-line"></i>
                                                                            </button>
                                                                        </li>
                                                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => paginate(totalPages)}>
                                                                                <i className="ri-arrow-right-double-fill"></i>
                                                                            </button>
                                                                        </li>
                                                                    </ul>
                                                                </nav>
                                                            </div>
                                                            <div className="col-auto">
                                                                <p className="mt-1 mb-0">Page Showing {currentPage} of {totalPages}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {/* Assign Project Modal */}
                                    <Modal show={showModal} onHide={handleClose} centered>
                                        <Modal.Header closeButton>
                                            <Modal.Title>Assign Project</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <Form>
                                                <div className="row">
                                                    <Form.Group className="form-group col-md-12 col-lg-12" controlId="ProjectName">
                                                        <Form.Label className="text-left d-block required">Project Name</Form.Label>
                                                        <Select
                                                            className="react-select-container"
                                                            classNamePrefix="react-select"
                                                            name="ProjectName"
                                                            options={Projectoptions}
                                                            onChange={(option) => handleChange({ target: { name: 'ProjectName', value: option.value } })}
                                                            value={Projectoptions.find(option => option.value === formData.ProjectName)}
                                                            placeholder="Select Project"
                                                            components={{ ClearIndicator }}
                                                            isClearable
                                                            menuPortalTarget={document.body}
                                                            styles={{
                                                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                control: base => ({ ...base, zIndex: 1 })
                                                            }}
                                                        />

                                                    </Form.Group>
                                                    <Form.Group className="form-group col-md-12 col-lg-12" controlId="OfficialEmail">
                                                        <Form.Label className="text-left d-block required">Resource</Form.Label>
                                                        <Select
                                                            className="react-select-container"
                                                            classNamePrefix="react-select"
                                                            name="Resource"
                                                            options={Resourceoptions}
                                                            onChange={(option) => handleChange({ target: { name: 'Resource', value: option.value } })}
                                                            value={Resourceoptions.find(option => option.value === formData.Resource)}
                                                            placeholder="Select Resource"
                                                            components={{ ClearIndicator }}
                                                            isClearable
                                                            menuPortalTarget={document.body}
                                                            styles={{
                                                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                control: base => ({ ...base, zIndex: 1 })
                                                            }}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group className="form-group col-md-6 col-lg-6" controlId="startDate">
                                                        <Form.Label className="text-left d-block required">Start Date</Form.Label>
                                                        <Form.Control type="date" name='StartDate' value={(formData.StartDate)} onChange={handleChange} required />
                                                    </Form.Group>
                                                    <Form.Group className="form-group col-md-6 col-lg-6" controlId="endDate">
                                                        <Form.Label className="text-left d-block required">End Date</Form.Label>
                                                        <Form.Control type="date" name='EndDate' value={formData.EndDate} onChange={handleChange} required />
                                                    </Form.Group>
                                                    <Form.Group className="col-md-12 col-lg-12" controlId="description">
                                                        <Form.Label className="text-left d-block">Description</Form.Label>
                                                        <Form.Control as="textarea" name='Description' rows={3} value={formData.Description} onChange={handleChange} required />
                                                    </Form.Group>
                                                </div>
                                            </Form>
                                        </Modal.Body>
                                        <Modal.Footer className="d-flex justify-content-center">
                                            <Button variant="light" onClick={handleClose}>
                                                Cancel
                                            </Button>
                                            <Button variant="primary" onClick={handleSubmit}>
                                                Submit <i class="ri-checkbox-circle-line"></i>
                                            </Button>
                                        </Modal.Footer>
                                    </Modal>
                                    {/* Update Assigned Project Modal */}
                                    <Modal show={updateShowModal} onHide={handleUpdateClose} centered>
                                        <Modal.Header closeButton>
                                            <Modal.Title>Update Assigned Project</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <Form>
                                                <div className="row">
                                                    <Form.Group className="form-group col-md-12 col-lg-12" controlId="projectName">
                                                        <Form.Label className="text-left d-block">Project Name</Form.Label>
                                                        <Select
                                                            className="react-select-container"
                                                            classNamePrefix="react-select"
                                                            name='projectName'
                                                            value={selectedProject ? { value: selectedProject.projectName, label: selectedProject.projectName } : null}
                                                            options={Projectoptions}
                                                            isDisabled={true}
                                                            placeholder="Choose..."
                                                            components={{ ClearIndicator }}
                                                            isClearable
                                                            menuPortalTarget={document.body}
                                                            styles={{
                                                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                control: base => ({ ...base, zIndex: 1 })
                                                            }}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group className="form-group col-md-12 col-lg-12" controlId="projectName">
                                                        <Form.Label className="text-left d-block">Resource</Form.Label>
                                                        <Select
                                                            className="react-select-container"
                                                            classNamePrefix="react-select"
                                                            name='projectName'
                                                            value={selectedProject ? { value: selectedProject?.resource, label: selectedProject?.resource } : null}
                                                            isDisabled={true}
                                                            placeholder="Choose..."
                                                            components={{ ClearIndicator }}
                                                            isClearable
                                                            menuPortalTarget={document.body}
                                                            styles={{
                                                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                control: base => ({ ...base, zIndex: 1 })
                                                            }}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group className="form-group col-md-6 col-lg-6">
                                                        <Form.Label className="text-left d-block">Start Date</Form.Label>
                                                        <Form.Control
                                                            type="date"
                                                            name="StartDate"
                                                            value={selectedProject?.startDate ? moment(selectedProject.startDate).format("YYYY-MM-DD") : ''}
                                                            onChange={handleUpdateChange}
                                                            required
                                                            disabled
                                                        />
                                                    </Form.Group>
                                                    <Form.Group className="form-group col-md-6 col-lg-6">
                                                        <Form.Label className="text-left d-block">End Date</Form.Label>
                                                        <Form.Control
                                                            type="date"
                                                            name="EndDate"
                                                            value={selectedProject?.endDate ? moment(selectedProject.endDate).format("YYYY-MM-DD") : ''}
                                                            onChange={handleUpdateChange}
                                                            required
                                                        />
                                                    </Form.Group>
                                                    <Form.Group className="col-md-12 col-lg-12" controlId="description">
                                                        <Form.Label className="text-left d-block">Description</Form.Label>
                                                        <Form.Control
                                                            as="textarea"
                                                            name="description"
                                                            rows={3}
                                                            value={selectedProject?.description || ''}
                                                            onChange={handleUpdateChange}
                                                            required
                                                        />
                                                    </Form.Group>

                                                </div>
                                            </Form>
                                        </Modal.Body>
                                        <Modal.Footer className="d-flex justify-content-center">
                                            <Button variant="secondary" onClick={handleUpdateClose}>
                                                Cancel
                                            </Button>
                                            <Button variant="primary" onClick={handleUpdate}>
                                                Submit <i className="ri-checkbox-circle-line"></i>
                                            </Button>
                                        </Modal.Footer>
                                    </Modal>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}
